import axios from 'axios';
import router from '../router';
import store from '../vuex/store';
import {Message} from 'element-ui'

axios.interceptors.response.use(function (response) {
    // 在发送请求之前做些什么
    return response;
  }, function (error) {
    // 对请求错误做些什么
    if(error.response.status === 401){
        Message.error('授权已过期,请重新登录')
        store.commit('logout', 'false')
        router.push({ path: '/login' })
    }
    return Promise.reject(error);
  });


// const httpUrl = 'http://192.168.0.101:10801'
const httpUrl = ''

// 通用公用方法
const req = (method, url, params) => {
    let headers = {
        'Content-Type': 'application/json',
        'HMToken': localStorage.getItem('authToken')
    }

    return axios({
        method: method,
        url: httpUrl+url,
        headers: headers,
        data: params,
    }).then(res => {
        return res.data
    }).catch(err =>{
        console.log(err)
    });
};

const reqGet = (method, url, params) => {
    return axios({
        method: method,
        url: httpUrl+url,
        headers: {
            'Content-Type': 'application/json',
            HMToken: localStorage.getItem('authToken')
        },
        data: params,
        responseType: 'blob',
    }).then(res => {
        if(res && res.data){
            return res.data
        }
        return res
    })
};

const reqb = (method, url, params) => {
    let headers = {
        'HMToken': localStorage.getItem('authToken')
    }
    // var myHeaders = new Headers();
    // if(localStorage.getItem('authToken')){
    // }
    // myHeaders.append("SeerToken", localStorage.getItem('authToken'));

    return axios({
        method: method,
        url: httpUrl+url,
        "contentType": false,
        "mimeType": "multipart/form-data",
        headers: headers,
        "processData": false,
        data: params,
    }).then(res => {
        return res.data
    }).catch(err =>{
        console.log(err)
    });
};

const upHttp = async(url,parms)=>{
    let obj = {
        method: 'post',
        headers: {
          'HMToken': localStorage.getItem('authToken')
      }
    }
    if(parms){
        obj.body = parms
        // obj.redirect = 'follow'
    }
    try {
        const response = await fetch(httpUrl+url,obj);
        if(response.status == 200){
            return response.json();
        }else if(response.status == 401){
            return
        }else{
            console.log('response error')
            console.log(response)
        }
    } catch(err) {
        console.log(err);
    }
}

export {
    req,reqb,upHttp,reqGet
}


// WEBPACK FOOTER //
// ./src/api/axiosFun.js